import Layout from "components/layout/Layout";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import config from "../config";
import { formatDate } from "../utils";

const BlogDetails = () => {
  const { slug } = useParams();
  const [blogDetails, setBlogDetails] = useState([])

  useEffect(() => {
    const fetchBlogDetail = async () => {
      try {
        const response = await fetch(
            `${config.endpoints.baseUrl}/api/posts/show/${slug}`
        )
        const result = await response.json()
        setBlogDetails(result.data)
      } catch (error) {
        console.error("Error fetching blog data:", error)
      }
    }
    fetchBlogDetail()
  }, [slug])

  return (
    <Layout
      headerStyle={1}
      footerStyle={1}
      breadcrumbTitle={
        <>
          {blogDetails?.title}
        </>
      }
    >
      <section className="blog-details-area pb-150">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="blog-details-wrap">
                <div className="blog-details-thumb">
                  <img src={blogDetails?.image} alt={blogDetails?.title} />
                </div>
                <div className="blog-details-content">
                  <span className="date desc">{formatDate(blogDetails?.created_at)}</span>
                  <div className="default"
                       dangerouslySetInnerHTML={{ __html: blogDetails?.text }}>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};
export default BlogDetails;
